import React from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "redux";
import rootreducer from "./helpers/store/Reducers/rootreducer";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { initSentry, Sentry, captureException } from "./helpers/context/sentry";
import { initMixpanel } from "./helpers/context/mixpanel";

initSentry();
initMixpanel();

const store = createStore(rootreducer);
const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p style={{ padding: 24 }}>Something went wrong. Please refresh the page.</p>}
      showDialog={false}
      onError={(error, componentStack) => {
        captureException(error, {
          source: "ErrorBoundary",
          tags: { feature: "react" },
          componentStack,
        });
      }}
    >
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
